import React from 'react'
import cn from 'classnames'
import Logo from 'js/components/Logo'
import ZespriLogo from 'media/zespri-logo.svg?svgr-webpack'

type Props = {
  className?: string
  theme?: 'light' | 'dark'
}

const PartnershipLogo = ({ className, theme = 'dark' }: Props) => {
  const isLight = theme === 'light'
  const logoColorClass = isLight ? 'text-black' : 'text-white'
  return (
    <div className={cn('flex items-center gap-3', className)}>
      {/* Lifesum Logo */}
      <Logo className={logoColorClass} />

      {/* Partnership Symbol */}
      <span
        className={cn('text-lg font-light relative', logoColorClass)}
        style={{ top: '2px' }}
      >
        ×
      </span>

      {/* Zespri Logo */}
      <ZespriLogo
        className={logoColorClass + ' w-auto'}
        style={{ height: '2.5rem' }}
      />
    </div>
  )
}

export default PartnershipLogo
